<template>
  <div>
    <div class="caption font-weight-medium mb-2">Vias</div>
    <div class="caption mb-2 grey--text text--darken-1">Pick a city from the list or type a custom via.</div>
    <div v-for="(via, index) in vias" :key="index" class="d-flex align-center mb-2" style="gap: 8px">
      <autocomplete-string-free-text
        class="flex-grow-1"
        :items="cities"
        :value="via"
        :disabled="disabled"
        placeholder="City or custom via"
        @input="updateVia(index, $event)"
      />
      <v-btn icon small :disabled="disabled || index === 0" @click="moveUp(index)">
        <v-icon small>mdi-arrow-up</v-icon>
      </v-btn>
      <v-btn icon small :disabled="disabled || index === vias.length - 1" @click="moveDown(index)">
        <v-icon small>mdi-arrow-down</v-icon>
      </v-btn>
      <v-btn icon small color="error" :disabled="disabled" @click="removeVia(index)">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-btn text small color="primary" class="mt-1" :disabled="disabled" @click="addVia">
      <v-icon small left>mdi-plus</v-icon>
      Add via
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    vias() {
      return Array.isArray(this.value) ? this.value : [];
    },
  },
  methods: {
    emit(next) {
      this.$emit("input", next);
    },
    addVia() {
      this.emit([...this.vias, ""]);
    },
    removeVia(index) {
      const next = [...this.vias];
      next.splice(index, 1);
      this.emit(next);
    },
    updateVia(index, value) {
      const next = [...this.vias];
      next[index] = value == null ? "" : String(value).trim();
      this.emit(next);
    },
    moveUp(index) {
      if (index <= 0) return;
      const next = [...this.vias];
      const tmp = next[index - 1];
      next[index - 1] = next[index];
      next[index] = tmp;
      this.emit(next);
    },
    moveDown(index) {
      if (index >= this.vias.length - 1) return;
      const next = [...this.vias];
      const tmp = next[index + 1];
      next[index + 1] = next[index];
      next[index] = tmp;
      this.emit(next);
    },
  },
};
</script>
